import React from 'react';
import { Box } from '@mui/material';
import NoRecords from './application/no-records';

interface NoRecordsOverlayProps {
  isLoading?: boolean;
  message: string;
  dataLength?: number;
}

const NoRecordsOverlay: React.FC<NoRecordsOverlayProps> = ({
  isLoading,
  message,
  dataLength
}) => {
  if (!isLoading && dataLength === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          height: '100%',
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <NoRecords message={message} />
      </Box>
    );
  }
  return null;
};

export default NoRecordsOverlay;
